/**
 * Created by neo on 12.04.22.
 */
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';
import { LocalizedEntity, createLocalizedEntity } from '../../../LocalizedEntity';
import { MindfulnessProgramTemplateDay, createMindfulnessProgramTemplateDay } from './MindfulnessProgramTemplateDay';

export type MindfulnessProgramTemplatePhase = LocalizedEntity & {
  type: string;
  days: MindfulnessProgramTemplateDay[];
  cycles: number;
  readonly minDurationInMinutes: number | undefined;
  readonly maxDurationInMinutes: number | undefined;
  readonly totalUnits: number;
  readonly totalUnitsWithWeeks: number;
  toJS(newId?: boolean): any;
};

export function createMindfulnessProgramTemplatePhase(json?: Partial<MindfulnessProgramTemplatePhase>): MindfulnessProgramTemplatePhase {
  const base = createLocalizedEntity(json as any);
  return makeAutoObservable({
    ...base,
    type: json?.type ?? '',
    days: (json?.days ?? []).map((d: any) => createMindfulnessProgramTemplateDay(d)),
    cycles: json?.cycles ?? 1,

    get minDurationInMinutes(): number | undefined {
      return this.days.reduce(
        (agg, cycle) =>
          cycle.minDurationInMinutes ? Math.min(cycle.minDurationInMinutes, agg ?? Number.MAX_SAFE_INTEGER) : agg,
        undefined as number | undefined,
      );
    },

    get maxDurationInMinutes(): number | undefined {
      return this.days.reduce(
        (agg, cycle) =>
          cycle.maxDurationInMinutes ? Math.max(cycle.maxDurationInMinutes, agg ?? Number.MIN_SAFE_INTEGER) : agg,
        undefined as number | undefined,
      );
    },

    get totalUnits(): number {
      return this.days.reduce((total, day) => total + day.units.length, 0);
    },

    get totalUnitsWithWeeks(): number {
      return this.days.reduce((total, day) => total + day.units.length, 0) * this.cycles;
    },

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        type: this.type,
        days: this.days.map((d) => d.toJS(newId)),
        cycles: this.cycles,
      };
    },
  });
}
